/**
 * Floating Footer Handler
 * Manages the visibility and behavior of floating footers based on the user's scroll position relative to the bottom of the page.
 */

document.addEventListener("DOMContentLoaded", () => {
	// Select all floating footer elements
	const floatingFooters = document.querySelectorAll(".bds-tray");

	if (!floatingFooters.length) return;

	/**
	 * Handles the scroll behavior and checks if the user is at the bottom of the page.
	 * Toggles the "at-bottom" class on floating footers as needed.
	 */
	function handleScroll() {
		const viewportHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		const scrollPosition = window.scrollY;

		const distanceFromBottom =
			documentHeight - (scrollPosition + viewportHeight);

		floatingFooters.forEach((floatingFooter) => {
			if (distanceFromBottom <= 0) {
				floatingFooter.classList.add("at-bottom");
			} else {
				floatingFooter.classList.remove("at-bottom");
			}
		});
	}

	// Attach the scroll event listener
	window.addEventListener("scroll", handleScroll, { passive: true });
});
